/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Whtr_Band_Note_HighInputs */

const en_us2_body_assessment_whtr_band_note_high = /** @type {(inputs: Body_Assessment_Whtr_Band_Note_HighInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your waist is over 60% of your height. NICE ties that range to high cardiometabolic risk.`)
};

const pt_br2_body_assessment_whtr_band_note_high = /** @type {(inputs: Body_Assessment_Whtr_Band_Note_HighInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A sua cintura está acima de 60% da altura. O NICE associa essa faixa a risco cardiometabólico alto.`)
};

const es_419_body_assessment_whtr_band_note_high = /** @type {(inputs: Body_Assessment_Whtr_Band_Note_HighInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu cintura está por encima del 60% de tu estatura. El NICE asocia ese rango con un riesgo cardiometabólico alto.`)
};

const pt_pt2_body_assessment_whtr_band_note_high = /** @type {(inputs: Body_Assessment_Whtr_Band_Note_HighInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A tua cintura está acima de 60% da altura. O NICE associa este intervalo a um risco cardiometabólico elevado.`)
};

const fr_fr2_body_assessment_whtr_band_note_high = /** @type {(inputs: Body_Assessment_Whtr_Band_Note_HighInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ton tour de taille dépasse 60 % de ta hauteur. Le NICE associe cette zone à un risque cardiométabolique élevé.`)
};

const de_de2_body_assessment_whtr_band_note_high = /** @type {(inputs: Body_Assessment_Whtr_Band_Note_HighInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deine Taille liegt über 60 % deiner Größe. NICE verbindet diesen Bereich mit hohem kardiometabolischem Risiko.`)
};

const it_it2_body_assessment_whtr_band_note_high = /** @type {(inputs: Body_Assessment_Whtr_Band_Note_HighInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La tua vita è oltre il 60% dell'altezza. Il NICE associa questo intervallo a un rischio cardiometabolico alto.`)
};

/**
* | output |
* | --- |
* | "Your waist is over 60% of your height. NICE ties that range to high cardiometabolic risk." |
*
* @param {Body_Assessment_Whtr_Band_Note_HighInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_whtr_band_note_high = /** @type {((inputs?: Body_Assessment_Whtr_Band_Note_HighInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Whtr_Band_Note_HighInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_whtr_band_note_high(inputs)
	if (locale === "es-419") return es_419_body_assessment_whtr_band_note_high(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_whtr_band_note_high(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_whtr_band_note_high(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_whtr_band_note_high(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_whtr_band_note_high(inputs)
	return en_us2_body_assessment_whtr_band_note_high(inputs)
});
export { body_assessment_whtr_band_note_high as "body-assessment.whtr_band_note.high" }